<script>
    import { changeData } from '@/scripts/tools.js';

    export default {
        data() {
            return {
                errorText: '',
            }
        },
        computed: {
            addData() {return this.$store.getters.ASSET_TYPE_DATA_ADD},
        },
        methods: {
            async updateData(event, fieldName, isCheckBox = false) {
                this.errorText = await changeData(
                    event, fieldName, 'ASSET_TYPE_DATA_ADD_UPDATE', 'CHECK_ASSET_TYPE_ADD', isCheckBox
                );
            },
        }
    }
</script>


<template>
    <div class="left_sub_panel_data">
        <label>Name:</label>
        <input 
            :value="addData['name']"
            @change="updateData($event, 'name')"
            type="text"
            class="right_input mt_5 mb_10"
        >

        <label>Description:</label>
        <input 
            :value="addData['description']"
            @change="updateData($event, 'description')"
            type="text"
            class="right_input mt_5 mb_10"
        >

        <label
            v-if="errorText !== ''"
            class="error_text mt_10"
        >{{ errorText }}</label>
    </div>
</template>